import './App.css';
// import NavBar from './components/navbar';
import Home from './routes/home';
import {Route, Routes} from 'react-router-dom';
import Service from './routes/service';
import Contact from './routes/contact';
import About from './routes/about';


function App() {
  return (
    <>
     <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/service' element = {<Service/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/contact' element = {<Contact/>}/>
     </Routes>
   
    </>
  );
}

export default App;
